export function emitOrderUpdatedEvent(order) {
  let event = document.createEvent('CustomEvent');
  event.initCustomEvent('orderUpdated', true, true, { order: order });
  document.dispatchEvent(event);
}
